<template>
  <div id="app">
    <router-view></router-view>
    <!-- <w-frame/> -->
    <!-- <w-login/> -->
  </div>
</template>

<script>
// import WLogin from './views/login';
// import WFrame from './views/frame';

export default {
  name: 'WApp',
  // components: {
  //   WLogin,
  //   WFrame,
  // },
  created() {
    //  this.$store.dispatch('setUserInfo', { managerId: 'administrator', managerName: '관리자', managerType: 'ADMIN', managerTypeName: '어드민' });
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue